import * as React from 'react';
import { handleQuoteFormEvent, logStep } from "./Utils";
import { QuoteFormEventType } from "./QuoteFormEventType";

interface ILogStepProps {
    lastStep?: string;
    nextStep?: string;
    stepNumber?: QuoteFormEventType;
    sectionName?: string;
    wizardName?: string;
    logStep?: boolean;
}

export function LogStep(props: ILogStepProps): JSX.Element {
    if (props.logStep) {
        React.useEffect(() => {
                logStep(props.lastStep, props.nextStep, props.wizardName);
                handleQuoteFormEvent(props.stepNumber, props.sectionName, props.wizardName);
            },
            []);
    }
    return null;
}